export default function (links) {
  let photos = [];

  const PHOTO_SWIPE_OPTIONS = {
    history: false,
    pinchToClose: false,
    closeOnScroll: false,
    showHideOpacity: true,
    errorMsg: '<div class="pswp__error-msg">Изображение загрузить не получилось</div>',
    bgOpacity: .7,
    index: 0,
    shareButtons: [
      {id:'download', label:'Загрузить изображение', url:'{{raw_image_url}}', download:true}
    ],
  };

  const click = function (e) {
    e.preventDefault();
    if(!window.PhotoSwipe || !window.PhotoSwipeUI_Default){
      return true
    }
    PHOTO_SWIPE_OPTIONS.index = this.index
    let gallery = new PhotoSwipe(document.querySelector('.pswp'), PhotoSwipeUI_Default, photos, PHOTO_SWIPE_OPTIONS);
    gallery.init();
    gallery.listen('beforeChange', function() {
      let item = gallery.currItem
      item.link && item.link.sliderMain && item.link.sliderMain.sliders &&
      item.link.sliderMain.sliders[0] && item.link.sliderMain.sliders[0].goTo(gallery.currItem.index)
    });
  }
  for (let i = 0; i < links.length; i++) {
    let link = links[i]
    link.index = i
    link.removeEventListener('click', click)
    link.addEventListener('click', click)
    photos.push({ w: Number(link.getAttribute('data-width')), h: Number(link.getAttribute('data-height')), src: link.getAttribute('href'), index: i, link })
  }
  return photos
}
